function loadScript(url, crossOrigin = true) {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.async = true;
    if (crossOrigin) {
      script.crossOrigin = 'anonymous';
    }

    script.onload = () => resolve();

    script.onerror = () => reject(new Error(`Load script from ${url} failed`));

    script.src = url;
    const head = document.head || document.getElementsByTagName('head')[0];
    (document.body || head).appendChild(script);
  });
}

export { loadScript };
